<template>
    <div>
        <h2 class="mt-6 text-3xl leading-9 font-extrabold text-gray-900">
            {{ $t('auth.forceNewPassword.pageTitle') }}
        </h2>

        <p class="mt-6 flex flex-col justify-between text-sm leading-5">
            {{ $t('auth.forceNewPassword.instructions') }}
        </p>

        <div class="mt-8">
            <form class="mt-6" @submit="setPassword">
                <apexo-input-group class="mt-5" :label="$t('auth.forceNewPassword.currentPassword')">
                    <apexo-input
                        name="current-password"
                        type="password"
                        v-model="current_password"
                    />
                </apexo-input-group>
                <apexo-input-group class="mt-5" :label="$t('auth.forceNewPassword.password')">
                    <apexo-input
                        name="password"
                        type="password"
                        v-model="password"
                    />
                </apexo-input-group>
                <apexo-input-group class="mt-5" :label="$t('auth.forceNewPassword.passwordConfirmation')">
                    <apexo-input
                        name="passwordConfirmation"
                        type="password"
                        v-model="password_confirmation"
                    />
                </apexo-input-group>

                <div class="flex rounded border border-red-200 mt-4 p-4 bg-red-100 text-red-600 text-sm" v-if="error">
                    {{ $t(error) }}
                </div>

                <apexo-button
                    class="mt-6"
                    :disabled="!valid"
                    @click="setPassword"
                >
                    {{ $t('auth.forceNewPassword.changePassword') }}
                </apexo-button>
            </form>
        </div>
    </div>
</template>

<script>
    import ApexoButton from '@/components/Elements/ApexoButton.vue';
    import ApexoInput from '@/components/Elements/ApexoInput.vue';
    import ApexoInputGroup from '@/components/Elements/ApexoInputGroup';
    import { mapState } from 'vuex';

    export default {
        components: {
            ApexoInputGroup,
            ApexoButton,
            ApexoInput,
        },

        data() {
            return {
                current_password: '',
                password: '',
                password_confirmation: '',
                error: '',
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            valid() {
                return this.current_password &&
                    this.password.length >= 8 &&
                    this.password_confirmation.length >= 8;
            },
        },

        methods: {
            async setPassword() {
                if (!this.valid) {
                    return;
                }

                try {
                    await this.$axios.put(`/users/${this.authUser.id}/set-password`, {
                        current_password: this.current_password,
                        password: this.password,
                        password_confirmation: this.password_confirmation,
                    });

                    this.$router.replace({ name: 'orders' });
                } catch (error) {
                    const errorBag = error.response.data.errors;

                    if (errorBag.current_password) {
                        this.error = 'auth.forceNewPassword.errors.currentPassword';
                    }

                    if (errorBag.password_confirmation) {
                        this.error = 'auth.forceNewPassword.errors.passwordConfirmation';
                    }
                }
            },
        },
    };
</script>
